import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { MainContext } from "../../../../main/context/MainContextProvider";
import type { EquipmentDowntimeGroup } from "../../types";
import DowntimeEquipmentChart from "./DowntimeEquipmentChart";

export type DowntimeByEquipmentSectionProps = {
  equipmentGroups: EquipmentDowntimeGroup[];
};

export default function DowntimeByEquipmentSection({
  equipmentGroups,
}: DowntimeByEquipmentSectionProps) {
  const { theme } = useContext(MainContext);

  if (equipmentGroups.length === 0) {
    return null;
  }

  const hasData = equipmentGroups.some((g) => g.data.length > 0);
  if (!hasData) {
    return null;
  }

  return (
    <Box sx={{ marginTop: 2, width: "100%" }}>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          color: theme.primaryTextColor,
          marginBottom: 1.5,
          textAlign: "left",
        }}
      >
        Tempo de Indisponibilidade por Equipamento
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 2,
        }}
      >
        {equipmentGroups.map((group) => (
          <DowntimeEquipmentChart
            key={group.equipmentType}
            title={group.label}
            color={group.color}
            data={group.data}
            averageDowntimeFormatted={group.averageDowntimeFormatted}
          />
        ))}
      </Box>
    </Box>
  );
}
